// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__i4XRd","emails":"CreateEditClinics_emails__3HhNG","emailTagLabel":"CreateEditClinics_emailTagLabel__WGPUh"};